<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="el-icon-s-check"></i> 员工列表 </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                    v-if="perData.allow_dele == 1"
                    >批量删除</el-button
                >
                <el-select
                    v-if="systemSet.isstores == 1"
                    v-model="storeBar"
                    filterable
                    clearable
                    default-first-option
                    placeholder="门店"
                    class="handle-select mr10"
                    @change="selectValue"
                >
                    <el-option v-for="(item, index) in allSelect.store" :key="index" :label="item.store_name" :value="item.store_no">
                        <span style="float: right">{{ item.store_name }}</span>
                        <span style="float: left; color: #8492a6; font-size: 13px">{{ item.store_no }}</span>
                    </el-option>
                </el-select>
                <el-select
                    v-model="bar"
                    filterable
                    clearable
                    default-first-option
                    placeholder="部门"
                    class="handle-select mr10"
                    @change="selectValue"
                >
                    <el-option v-for="(item, index) in allSelect.dept" :key="index" :label="item.dept_name" :value="item.dept_no">
                        <span style="float: right">{{ item.dept_name }}</span>
                        <span style="float: left; color: #8492a6; font-size: 13px">{{ item.dept_no }}</span>
                    </el-option>
                </el-select>
                <el-input v-model="name" placeholder="请输入员工名称，员工编号" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button style="float: right" type="primary" icon="el-icon-plus" @click="handleAdd" v-if="perData.allow_add == 1"
                    >添加</el-button
                >
            </div>
            <el-table
                :data="tableData"
                border
                stripe
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="login_staff" fixed="left" label="员工编号" width="180" align="center"></el-table-column>
                <el-table-column prop="staffr_name" label="员工名称" width="180" align="center"></el-table-column>
                <el-table-column prop="store_name" label="门店" width="180" align="center" v-if="systemSet.isstores == 1"></el-table-column>
                <el-table-column label="头像" align="center">
                    <template slot-scope="scope">
                        <el-image class="table-td-thumb" :src="scope.row.img" :preview-src-list="[scope.row.img]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="dept_name" label="部门" width="180" align="center"></el-table-column>
                <el-table-column prop="counter_name" label="操作柜台" width="180" align="center"></el-table-column>
                <el-table-column prop="telephone" label="联系电话" width="120" align="center"></el-table-column>
                <el-table-column prop="bindDevice" label="绑定设备" width="120" align="center"></el-table-column>
                <el-table-column label="使用系统" align="center" width="120">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.allow_login == '1' ? 'success' : scope.row.allow_login == '0' ? 'danger' : ''">{{
                            scope.row.allow_login == 1 ? '启用' : '停用'
                        }}</el-tag>
                        <el-switch
                            style="margin-left: 5px"
                            v-model="scope.row.allow_login"
                            :active-value="1"
                            :inactive-value="0"
                            @change="tableDatastates(scope.row, 'allow_login')"
                        >
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center" width="120">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.enable == '1' ? 'success' : scope.row.enable == '0' ? 'danger' : ''">{{
                            scope.row.enable == 1 ? '启用' : '停用'
                        }}</el-tag>
                        <el-switch
                            style="margin-left: 5px"
                            v-model="scope.row.enable"
                            :active-value="1"
                            :inactive-value="0"
                            @change="tableDatastates(scope.row, 'enable')"
                        >
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="build_name" :label="$t('common.creator')" width="150" align="center"></el-table-column>
                <el-table-column prop="build_date" :label="$t('common.createTime')" width="160" align="center"></el-table-column>
                <el-table-column prop="modify_name" :label="$t('common.modifier')" width="150" align="center"></el-table-column>
                <el-table-column prop="modify_date" :label="$t('common.modifyTime')" width="160" align="center"></el-table-column>
                <el-table-column
                    label="操作"
                    fixed="right"
                    width="380"
                    align="center"
                    v-if="perData.allow_edit == 1 || perData.allow_dele == 1 || perbtnData.allow_use == 1"
                >
                    <template slot-scope="scope">
                        <!-- <el-button @click="checkBind(scope)" v-if="perData.allow_edit == 1">查看绑定</el-button> -->
                        <el-button type="primary" plain icon="el-icon-edit" @click="handleEdit(scope)" v-if="perData.allow_edit == 1"
                            >{{ $t('common.edit') }}</el-button
                        >
                        <el-button type="danger" icon="el-icon-delete" plain v-if="perData.allow_dele == 1" @click="handleDelete(scope)"
                            >{{ $t('common.delete') }}</el-button
                        >
                        <el-button
                            type="warning"
                            plain
                            icon="el-icon-s-operation"
                            @click="handlePermission(scope.row.login_staff)"
                            v-if="perbtnData.allow_edit == 1"
                            >设置权限</el-button
                        >
                        <el-button type="primary" plain @click="handleDevice(scope.row)">绑定设备</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="pageIndex"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 添加弹出框 -->
        <el-dialog :title="isAdd ? $t('common.add') : $t('common.edit')" :visible.sync="addData_isshow" width="40%">
            <el-form :rules="rules" ref="addform" :model="addData" label-width="100px" style="display: flex; flex-wrap: wrap">
                <div width="100%">
                    <div class="aaa">
                        <div>
                            <div class="aaa" style="flex-direction: column">
                                <el-form-item label="员工编号" prop="login_staff">
                                    <el-input v-model="addData.login_staff" @blur="blurLoginstaff" :disabled="!isAdd"></el-input>
                                </el-form-item>

                                <el-form-item label="员工名称">
                                    <el-input v-model="addData.staffr_name"></el-input>
                                </el-form-item>
                            </div>
                            <div class="aaa" style="flex-direction: column">
                                <el-form-item label="登录密码">
                                    <label slot="label">登录密码</label>
                                    <el-input type="password" v-model="addData.password" show-password></el-input>
                                </el-form-item>
                                <el-form-item label="所属门店" prop="store_no" v-if="systemSet.isstores == 1">
                                    <el-select
                                        v-model="addData.store_no"
                                        clearable
                                        filterable
                                        default-first-option
                                        @change="changeStore(addData.store_no, '2')"
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            v-for="(item, index) in allSelect.store"
                                            :key="index"
                                            :label="item.store_name"
                                            :value="item.store_no"
                                        >
                                            <span style="margin-left: 10px">{{ item.store_name }}</span>
                                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.store_no }}</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="aaa" style="flex-direction: column">
                                <el-form-item label="职位">
                                    <el-select v-model="addData.position_no" filterable default-first-option placeholder="请选择职位">
                                        <el-option
                                            v-for="(item, index) in allSelect.position"
                                            :key="index"
                                            :label="item.kind_name"
                                            :value="item.kind_no"
                                        >
                                            <span style="margin-left: 10px">{{ item.kind_name }}</span>
                                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.kind_no }}</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="联络人">
                                    <label slot="label">联&nbsp;&nbsp;络&nbsp;&nbsp;人</label>
                                    <el-input v-model="addData.contact"></el-input>
                                </el-form-item>
                                <el-form-item label="是否启用">
                                    <el-tag :type="addData.enable == '1' ? 'success' : addData.enable == '0' ? 'danger' : ''">{{
                                        addData.enable == '1' ? '启用' : '停用'
                                    }}</el-tag>
                                    <el-switch style="margin-left: 5px" v-model="addData.enable" :active-value="1" :inactive-value="0">
                                    </el-switch>
                                </el-form-item>
                            </div>
                        </div>
                        <div>
                            <el-form-item label="头像" class="people">
                                <label slot="label">头&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;像</label>
                                <imgUpload
                                    :disableds="true"
                                    :onSuccess="form_Upload"
                                    :imageUrl="addData.img"
                                    :data="uploadData"
                                    @resetImg="resetImg"
                                />
                                <!--    <el-upload
                                    action="apiUpload"
                                    :http-request="uploadSectionFile"
                                    :show-file-list="false"
                                    style="display: inline-block"
                                >
                                    <i v-if="!imageUrl" class="el-icon-plus avatar-uploader-icon"></i>
                                    <img :src="imageUrl" alt="" class="avatar" />
                                </el-upload> -->
                            </el-form-item>
                            <div class="aaa" style="flex-direction: column">
                                <el-form-item label="联系电话">
                                    <label slot="label">联系电话</label>
                                    <el-input v-model="addData.telephone"></el-input>
                                </el-form-item>
                                <el-form-item label="联络人电话">
                                    <el-input v-model="addData.c_telephone"></el-input>
                                </el-form-item>
                                <el-form-item label="是否业务员">
                                    <el-tag :type="addData.issalesman == '1' ? 'success' : addData.issalesman == '0' ? 'danger' : ''">{{
                                        addData.issalesman == '1' ? '是' : '否'
                                    }}</el-tag>
                                    <el-switch style="margin-left: 5px" v-model="addData.issalesman" :active-value="1" :inactive-value="0">
                                    </el-switch>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div style="flex-direction: column; width: 100%">
                        <el-form-item label="使用系统">
                            <el-tag :type="addData.allow_login == '1' ? 'success' : addData.allow_login == '0' ? 'danger' : ''">{{
                                addData.allow_login == '1' ? '使用' : '不使用'
                            }}</el-tag>
                            <el-switch style="margin-left: 5px" v-model="addData.allow_login" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="部门">
                            <el-select
                                v-model="addData.dept_no"
                                clearable
                                filterable
                                multiple
                                default-first-option
                                placeholder="请选择部门"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="(item, index) in pullData.dept"
                                    :key="index"
                                    :label="item.dept_name"
                                    :value="item.dept_no"
                                >
                                    <span style="margin-left: 10px">{{ item.dept_name }}</span>
                                    <span style="float: left; color: #8492a6; font-size: 13px">{{ item.dept_no }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('common.counter') ">
                            <el-select
                                v-model="addData.counter_no"
                                clearable
                                multiple
                                filterable
                                default-first-option
                                placeholder="请选择"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="(item, index) in pullData.counter"
                                    :key="index"
                                    :label="item.counter_name"
                                    :value="item.counter_no"
                                >
                                    <span style="margin-left: 10px">{{ item.counter_name }}</span>
                                    <span style="float: left; color: #8492a6; font-size: 13px">{{ item.counter_no }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('common.remark')">
                            <el-input type="textarea" v-model="addData.remark" style="width: 100%"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clear()">取 消</el-button>
                <el-button type="primary" @click="saveAdd">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="温馨提示" :visible.sync="dialogVisibleDevice" width="40%" :before-close="handleClose">
            <div style="padding: 20px">
                <div>系统会根据您当前设备的特征生成唯一的设备指纹，并账号绑定。</div>
                <div>以下情况可能导致设备指纹变化，影响登录：</div>
                <div style="margin-left: 20px">
                    <ul>
                        <li>更换或重装浏览器。</li>
                        <li>操作系统升级或重装。</li>
                        <li>硬件更换（如显卡、硬盘）。</li>
                        <li>使用隐私模式或隐身窗口。</li>
                        <li>安装/卸载浏览器插件。</li>
                        <li>切换网络环境（如从Wi-Fi到移动数据）。</li>
                    </ul>
                </div>
                <div>为了避免因设备指纹变更而无法登录，请尽量保持设备和环境的稳定。如有变化请重新绑定新的设备指纹。</div>
                <br />
                <div>
                    <el-form ref="form" label-width="98px">
                        <el-form-item label="原设备指纹：">
                            {{ addData.visitorid }}
                        </el-form-item>
                        <el-form-item label="新设备指纹：">
                            <el-input v-model="visitorid"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleDevice = false">取 消</el-button>
                <el-button type="primary" @click="handleTrueDevice">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { compress } from '../../utils/request';
import {
    apiUploadOss_img,
    apisetListPeople,
    apialterStatusPeople,
    apialterStatusAllowLogin,
    apiaddSetPeople,
    apimodifySetPeople,
    apidelSetPeople,
    apiCurrentPermisson,
    apiAllSelectSetPeople,
    apiSetPeoplestorepull_staff,
    apiSetVipstoredel,
    apiSetPeoplestorebindDevice
} from '@/request/api';
export default {
    name: 'basetable',
    data() {
        return {
            visitorid: '',
            dialogVisibleDevice: false,
            uploadData: {
                url: 'staff'
            },
            isAdd: true,
            bar: '',
            storeBar: '',
            name: '',
            headerImage: '',
            picValue: '',
            pageIndex: 1,
            pageSize: 10,
            tableData: [],
            allSelect: '',
            perData: '',
            perbtnData: '',
            pullData: [],
            imageUrl: '',
            imgs: '',
            delList: [],
            addData_isshow: false,
            addData: {},
            pageTotal: 0,
            rules: {
                store_no: [{ required: true, message: '请选择门店', trigger: 'change' }],
                login_staff: [{ required: true, message: '请输入员工编号', trigger: 'blur' }],
                name: [
                    { required: true, message: '请输入员工名称', trigger: 'blur' },
                    { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                part: [{ required: true, message: '请选择所属部门', trigger: 'change' }]
            },

            systemSet: JSON.parse(localStorage.getItem('systemSet'))
        };
    },
    watch: {},
    computed: {
        headers() {
            return {
                Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
            };
        }
    },
    created() {
        this.getData();
        this.getSelectData();
        this.getPermission();
        this.getBtnPermission(); //获取 权限设置 按钮权限
    },
    activated() {
        this.getData();
        this.getSelectData();
        this.getPermission();
        this.getBtnPermission(); //获取 权限设置 按钮权限
    },

    mounted() {
        this.$fingerprint.then((fp) => {
            fp.get().then((result) => {
                this.visitorid = result.visitorId; // 这里获取设备的指纹ID
            });
        });
    },
    methods: {
        handleTrueDevice() {
            apiSetPeoplestorebindDevice({
                login_staff: this.addData.login_staff,
                visitorid: this.visitorid
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.success(res.data.info);
                }
                this.handleClose();
            });
        },
        handleDevice(row) {
            this.dialogVisibleDevice = true;
            this.addData = row;
            ['counter_no', 'dept_no'].forEach((key) => {
                if (typeof row[key] == 'string') {
                    this.addData[key] = row[key].split(',');
                }
            });
        },
        handleClose() {
            this.dialogVisibleDevice = false;
        },
        blurLoginstaff() {
            var pattern2 = /^[^\u4e00-\u9fa5]+$/; // 匹配汉字的正则表达式
            if (!pattern2.test(this.addData.login_staff)) {
                this.addData.login_staff = '';
                this.$message.error('员工编号不能包含中文字符');
                return;
            }
        },
        // 获取列表信息
        getData() {
            this.$load.show();
            apisetListPeople({
                page: this.pageIndex,
                page_size: this.pageSize,
                keyword: this.name,
                category_del_id: this.bar,
                store_del_id: this.storeBar
            }).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    //
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.page_total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 获取下拉列表信息
        getSelectData() {
            apiAllSelectSetPeople({}).then((res) => {
                if (res.code == 2000) {
                    this.allSelect = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '11'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getBtnPermission() {
            apiCurrentPermisson({
                id: '13'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perbtnData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //设置权限
        handlePermission(name) {
            localStorage.setItem('p_username', name);
            this.$router.push('/permission');
        },
        clear() {
            this.addData_isshow = false;
            this.getData();
        },
        resetImg(val) {
            apiSetVipstoredel({ filePath: this.addData.img }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.data);
                } else {
                    this.$message.error(res.msg);
                }
            });
            this.addData.img = val;
        },
        form_Upload(res) {
            // form 图片上传
            if (res.code != 2000) {
                this.$message.error('文件格式非jpeg,png,jpg,gif或文件大小超过2m！');
            }
            this.$set(this.addData, 'img', res.data.imgs);
        },
        // 压缩图片------------------------------------------------------------------
        uploadSectionFile(f) {
            //	附件上传
            let self = this;
            let Orientation;
            let ndata;

            if (f.file.size <= 1 * 1024 * 1024) {
                //判断图片是否大于1M,是就直接上传
                ndata = f.file;
                self.postImg(ndata);
            } else {
                //反之压缩图片
                let reader = new FileReader();
                // 将图片2将转成 base64 格式
                reader.readAsDataURL(f.file);

                // 读取成功后的回调
                reader.onloadend = function () {
                    let result = this.result;
                    let img = new Image();
                    img.src = result;
                    img.onload = function () {
                        let data = self.compress(img, Orientation);
                        self.headerImage = data;
                        ndata = self.compress(img, Orientation);

                        //BASE64转图片
                        var arr = ndata.split(','),
                            mime = arr[0].match(/:(.*?);/)[1],
                            bstr = atob(arr[1]),
                            n = bstr.length,
                            u8arr = new Uint8Array(n);
                        while (n--) {
                            u8arr[n] = bstr.charCodeAt(n);
                        }
                        ndata = new File([u8arr], f.file.name, { type: mime });
                        self.postImg(ndata);
                    };
                };
            }
        },
        async postImg(ndata) {
            let param = new FormData(); //创建form对象
            param.append('file', ndata); //通过append向form对象添加数据
            param.append('url', 'staff'); //文件夹名
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            try {
                const response = await apiUploadOss_img(param, config); //此处写接口对应的vue方法
                if (response.code == 2000) {
                    // this.handleFileUploadSuccess(response.Data);
                    this.imageUrl = response.data.imgs;
                    this.imgs = response.data.img;
                    this.addData.img = response.data.imgs;
                }
            } catch (error) {}
        },
        compress(img, Orientation) {
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            //瓦片canvas
            let tCanvas = document.createElement('canvas');
            let tctx = tCanvas.getContext('2d');
            let initSize = img.src.length;
            let width = img.width;
            let height = img.height;
            //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
            let ratio;
            if ((ratio = (width * height) / 4000000) > 1) {
                ratio = Math.sqrt(ratio);
                width /= ratio;
                height /= ratio;
            } else {
                ratio = 1;
            }
            canvas.width = width;
            canvas.height = height;
            //铺底色
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            //如果图片像素大于100万则使用瓦片绘制
            let count;
            if ((count = (width * height) / 1000000) > 1) {
                count = ~~(Math.sqrt(count) - 1); //计算要分成多少块瓦片
                //计算每块瓦片的宽和高
                let nw = ~~(width / count);
                let nh = ~~(height / count);
                tCanvas.width = nw;
                tCanvas.height = nh;
                for (let i = 0; i < count; i++) {
                    for (let j = 0; j < count; j++) {
                        tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
                    }
                }
            } else {
                ctx.drawImage(img, 0, 0, width, height);
            }
            //修复ios上传图片的时候 被旋转的问题
            if (Orientation != '' && Orientation != 1) {
                switch (Orientation) {
                    case 6: //需要顺时针（向左）90度旋转
                        this.rotateImg(img, 'left', canvas);
                        break;
                    case 8: //需要逆时针（向右）90度旋转
                        this.rotateImg(img, 'right', canvas);
                        break;
                    case 3: //需要180度旋转
                        this.rotateImg(img, 'right', canvas); //转两次
                        this.rotateImg(img, 'right', canvas);
                        break;
                }
            }
            //进行最小压缩
            let ndata = canvas.toDataURL('image/jpeg', 0.7); //原值0.1 很模糊 值越小越模糊，越大越清晰 内存越大

            //

            tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;

            return ndata;
        },
        // 限制上传的图片的格式大小--------------------------------------------------------
        beforeAvatarUpload(file) {
            var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            const extension = testmsg === 'jpg';
            const extension2 = testmsg === 'png';
            const isLt2M = file.size / 1024 / 1024 < 5;
            if (!extension && !extension2) {
                this.$message({
                    message: '上传文件只能是 jpg、png格式!',
                    type: 'warning'
                });
            }
            if (!isLt2M) {
                this.$message({
                    message: '上传文件大小不能超过 5MB!',
                    type: 'warning'
                });
            }
            return extension || (extension2 && isLt2M);
        },
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
            // this.imageUrl = file.response.data;
        },
        // 启用按钮
        tableDatastates(row, type) {
            let apiCall;
            if (type === 'enable') {
                apiCall = apialterStatusPeople({ enable: row.enable, login_staff: row.login_staff });
            } else {
                apiCall = apialterStatusAllowLogin({ allow_login: row.allow_login, login_staff: row.login_staff });
            }

            apiCall.then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg || '修改完成');
                } else {
                    this.$message.error((res.data && res.data.info) || res.msg || '操作失败');
                    // 恢复原来的开关状态
                    row[type] = type === 'enable' ? (row[type] === 1 ? 0 : 1) : (row[type] === 1 ? 0 : 1);
                }
            }).catch((error) => {
                this.$message.error('请求失败，请稍后重试');
                // 恢复原来的开关状态
                row[type] = type === 'enable' ? (row[type] === 1 ? 0 : 1) : (row[type] === 1 ? 0 : 1);
            });
        },
        // 触发搜索按钮---------------------------------------------------------------
        selectValue() {
            this.getData();
        },
        handleSearch() {
            this.pageIndex = 1;
            this.getData();
        },

        // 删除操作---------------------------------------------------------------
        handleDelete(scope) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apidelSetPeople({
                        login_staff: scope.row.login_staff
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 多选删除操作
        handleSelectionChange(user) {
            let arr = [];
            let arr1 = [];
            user.forEach(function (item, index, array) {
                arr.push(item.login_staff);
            });
            this.delList = arr;
        },
        delAllSelection() {
            if (this.delList.length <= 0) {
                this.$message({ message: '请先选择需要操作的对象', type: 'error' });
                return;
            }
            this.$confirm('此操作将批量删除, 是否继续?', '批量删除提示', {
                confirmButtonText: this.$t('common.confirm') ,
                cancelButtonText: this.$t('common.cancel') ,
                type: 'warning'
            })
                .then(() => {
                    apidelSetPeople({
                        login_staff: this.delList.join(',')
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {
                    // this.$message({ type: 'info',  message: '已取消删除' });
                });
        },
        // 查看绑定
        checkBind({ row }) {
            this.$router.push({ name: 'checkBind', params: { login_staff: row.login_staff } });
        },
        changeStore(e, r) {
            if (r == '2') {
                this.addData.dept_no = '';
                this.addData.counter_no = '';
            }
            apiSetPeoplestorepull_staff({
                store_no: e
            }).then((res) => {
                this.pullData = res.data;
            });
        },
        //添加----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.isAdd = true;
            this.addData_isshow = true;
            this.addData = {
                allow_login: '0',
                issalesman: '0',
                enable: '0'
            };

            if (this.allSelect.store) {
                const defaultStore = this.allSelect.store.find((store) => store.isdefault == 1);
                this.addData.store_no = defaultStore ? defaultStore.store_no : '';
                this.changeStore(defaultStore.store_no);
            }
        },
        // 编辑操作----------------------------------------------------------------------
        handleEdit(scope) {
            this.addData_isshow = true;
            this.isAdd = false;
            this.changeStore(scope.row.store_no);
            this.addData = scope.row;
            ['counter_no', 'dept_no'].forEach((key) => {
                if (typeof scope.row[key] == 'string') {
                    this.addData[key] = scope.row[key].split(',');
                }
            });
        },
        saveAdd() {
            let data = this.addData;
            console.log(data, 'data');
            this.$refs.addform.validate((valid) => {
                console.log(this.addform, '啊？');
                if (valid) {
                    ['counter_no', 'dept_no'].forEach((key) => {
                        if (data[key]) {
                            data[key] = data[key].join(',');
                        }
                    });
                    if (this.isAdd) {
                        data['img'] = this.imgs;
                        apiaddSetPeople(data).then((res) => {
                            if (res.code == 2000) {
                                this.$message({ message: '添加成功', type: 'success' });
                                this.addData_isshow = false;
                                this.getData();
                                this.imgs = '';
                                this.imageUrl = '';
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    } else {
                        apimodifySetPeople(data).then((res) => {
                            if (res.code == 2000) {
                                this.$message({ message: '修改成功', type: 'success' });
                                this.addData_isshow = false;
                                this.getData();
                                this.imgs = '';
                                this.imageUrl = '';
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    }
                } else {
                    return;
                }
            });
        },

        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            //
            this.pageSize = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.aaa {
    display: flex;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
<style>
.people .el-upload {
    width: 178px;
    height: 178px;
    border: 1px dashed #8c939d;
}
.people i {
    position: absolute;
    margin-left: 46%;
}
.el-table thead {
    color: rgb(182, 146, 146);
    font-weight: bold;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}
.el-table th {
    background: #ecf5ff !important;
}
</style>
